import { observer } from 'mobx-react-lite'
import { useState, useEffect, useCallback } from 'react'
import { IdleManagerStore } from 'entities/Auth/ui/IdleManager/store/IdleManagerStore'
import {
  ProviderIdleManager,
  useIdleManagerContext,
} from 'entities/Auth/ui/IdleManager/context/idleManagerContext'
import { useEntitiesContext } from 'entities/EntitiesExport'

const eventTypes = [
  // Keyboard
  'keydown',
  'keyup',
  'keypress',
  'input',
  // mouse
  'click',
  'dblclick',
  'mousedown',
  'mouseup',
  'mousemove',
  'mouseenter',
  'mouseleave',
  'mouseover',
  'mouseout',
  'contextmenu',
  'wheel',
  // Touch
  'touchstart',
  'touchend',
  'touchmove',
  'touchcancel',
  // Focus
  'focus',
  'blur',
  'focusin',
  'focusout',
  // Scroll
  'scroll',
]

const IdleManagerContent = observer(() => {
  const { authStore } = useEntitiesContext()
  const store = useIdleManagerContext()

  const callbackAllEvents = useCallback(() => {
    store.userIsActive()
  }, [])
  const callbackPageHide = useCallback(() => {
    store.closeTab()
  }, [])

  useEffect(() => {
    eventTypes.forEach((eventType) => {
      document.addEventListener(eventType, callbackAllEvents)
    })
    window.addEventListener('beforeunload', callbackPageHide)

    return () => {
      eventTypes.forEach((eventType) => {
        document.removeEventListener(eventType, callbackAllEvents)
      })
      window.removeEventListener('beforeunload', callbackPageHide)
      store.dispose()
    }
  }, [])

  useEffect(() => {
    if (authStore.isLoggedIn) {
      store.dispose()
      store.init()
    } else {
      store.dispose()
    }
  }, [authStore.isLoggedIn])

  return null
})

export const IdleManager = () => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new IdleManagerStore(entities))

  return (
    <ProviderIdleManager value={store}>
      <IdleManagerContent />
    </ProviderIdleManager>
  )
}
